export default __webpack_public_path__ + "static/media/bacolod.bc6e0439.jpg";